import { Auth } from 'aws-amplify'
import React, { useEffect, useState } from 'react'
import { Link, Redirect } from 'react-router-dom'
import Input from '../../Components/Input/Input'
import { LoginButton } from '../../Components/LoginButton'
import { useAuth } from '../../Utils.js/Auth/AuthDetails'
import classes from './SignUp.module.css'


function SingUp() {
    const { isAuthenticated, login: LoginGlobal, code, getAuthenticatedUser, loginError, setLoginValues } = useAuth()

    const [username, setUserName] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')

    const [disabled, setDisabled] = useState(false)
    const [loading, setLoading] = useState(false)
    const [verifyCode, setVerifyCode] = useState('')

    const login = () => {
        LoginGlobal(username, password)
    }


    async function verifyEmailValidationCode() {
        await Auth.confirmSignUp(username, verifyCode)
            .then(() => {
                login()
            })
            .catch((e) => {
                console.log('failed with error', e);
            });
    }

    const signup = () => {
        Auth.signUp({
            username,
            password,

        })
            .then((user) => {
                login()
            })
            .catch((err) => {
                setLoginValues((prev) => {
                    return {
                        ...prev,
                        loginError: err?.message
                    }
                })
                setLoading(false)

            })
    }



    useEffect(() => {
        if (
            username &&
            password
        ) {
            setDisabled(false)
        } else {
            setDisabled(true)
        }
    }, [
        username,
        password,

    ])


    useEffect(() => {
        if (loginError) {
            setLoginValues((prev) => {
                return {
                    ...prev,
                    loginError: null
                }
            })
        }
    }, [username, password])


    if (isAuthenticated) {
        return <Redirect
            to={{
                pathname: '/',
                state: { fromLogin: true }
            }}
        />
    }

    if (code === 'UserNotConfirmedException') {
        return (
            <div className={classes.container}>
                <Input
                    style={{
                        marginBottom: 24
                    }}
                    placeHolder='Verify'
                    value={verifyCode}
                    onChange={setVerifyCode}
                />

                <LoginButton
                    disabled={disabled}
                    style={{ margin: 'auto' }}
                    onPress={verifyEmailValidationCode}
                    title={'Verify'} />
            </div>
        )
    }
    return (
        <div className={classes.container}>
            <Input
                style={{
                    marginBottom: 24
                }}
                placeHolder='Email'
                value={username}
                onChange={setUserName}
            />
            <Input
                style={{
                    marginBottom: 24
                }}
                inputType='password'
                placeHolder='Password'
                value={password}
                onChange={setPassword}

            />
            <Input
                style={{
                    marginBottom: 48
                }}
                inputType='password'
                placeHolder='Confirm Password'
                value={confirmPassword}
                onChange={setConfirmPassword}

            />
            <LoginButton
                disabled={disabled}
                style={{ margin: 'auto' }}
                onPress={signup}
                title={'Create account'} />

        </div>
    )
}

export default SingUp